import { Component, HostListener, Input, OnInit, signal } from '@angular/core';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import { GlobalService } from '../service/global.service';

@Component({
    selector: 'pcg-tooltip-label'
    , templateUrl: './tooltip-label.component.html'
    , styleUrls: ['./tooltip-label.component.scss']
    , standalone: false
})
export class TooltipLabelComponent implements OnInit {

    @Input() tooltip!: string;
    @Input() labelText!: string;
    @Input() tooltipPlacement!: string;
    @Input() labelFontSize!: string;
    @Input() alwaysShowInfoIcon: boolean = false;

    faIconName = { faInfoCircle };

    isMobile = signal<boolean>(false);

    @HostListener('window:resize') onResize() { this.isMobile.set(GlobalService.setIsMobile(window.innerWidth));  }
    ngOnInit() { this.isMobile.set(GlobalService.setIsMobile(window.innerWidth)); }
}
